export const REQUEST_REASONS = "REQUEST_REASONS";
export const REQUEST_REASONS_SUCCEEDED = "REQUEST_REASONS_SUCCEEDED";
export const REQUEST_REASONS_FAILED = "REQUEST_REASONS_FAILED";
export const REQUEST_COMPLETE_REASONS = "REQUEST_COMPLETE_REASONS";
export const REQUEST_COMPLETE_REASONS_SUCCEEDED = "REQUEST_COMPLETE_REASONS_SUCCEEDED";
export const REQUEST_COMPLETE_REASONS_FAILED = "REQUEST_COMPLETE_REASONS_FAILED";

export const requestReasons = () => {
    return {
        type: REQUEST_REASONS,
    };
};

export const requestReasonsSucceeded = (payload) => {
    return {
        type: REQUEST_REASONS_SUCCEEDED,
        payload,
    };
};

export const requestReasonsFailed = (message) => {
    return {
        type: REQUEST_REASONS_FAILED,
        message,
    };
};

export const requestCompleteReasons = () => {
    return {
        type: REQUEST_COMPLETE_REASONS,
    };
};

export const requestCompleteReasonsSucceeded = (payload) => {
    return {
        type: REQUEST_COMPLETE_REASONS_SUCCEEDED,
        payload,
    };
};

export const requestCompleteReasonsFailed = (message) => {
    return {
        type: REQUEST_COMPLETE_REASONS_FAILED,
        message,
    };
};
